var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AgendaComponent',{ref:"agenda",attrs:{"places":_vm.places,"events":_vm.events},on:{"change":_vm.loadAgenda}})
}
var staticRenderFns = []

export { render, staticRenderFns }